import React from 'react';

export default function PageSubtitle(props) {
	// console.log('PageSubtitle', props);
	return (
		<h2
			className={`text-${props.alignment} + ' text-lg md:text-2xl font-light -mt-2 lg:-mt-4 md:mb-1 lg:mb-2`}
		>
			{props.subtitle}
		</h2>
	);
}
